import { MessageDescriptor } from 'react-intl';
import {
  AodRuleReportTypeEnum,
  AodRuleTriggerEnum,
} from '@app/modules/audit/modules/aod/aod.types';
import { activeStatusMessages, aodReportTypeMessages, triggerMessages } from '../../messages';

/**
 * Report type options for the reportType filter (value + message descriptor for $t).
 */
export const reportTypeOptions: ReadonlyArray<{
  value: string;
  message: MessageDescriptor;
}> = [
  {
    value: AodRuleReportTypeEnum.AUDIT_GIP_STATUS,
    message: aodReportTypeMessages[AodRuleReportTypeEnum.AUDIT_GIP_STATUS],
  },
  {
    value: AodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT,
    message: aodReportTypeMessages[AodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT],
  },
];

/**
 * Trigger options for the trigger filter (value + message descriptor, Spanish defaults).
 * Second option uses short label (Cierre + fin).
 */
export const triggerOptions: ReadonlyArray<{
  value: string;
  message: MessageDescriptor;
}> = [
  {
    value: AodRuleTriggerEnum.ORDER_END,
    message: triggerMessages.ORDER_END,
  },
  {
    value: AodRuleTriggerEnum.EOW_AND_ORDER_END,
    message: triggerMessages.EOW_AND_ORDER_END_SHORT,
  },
];

/**
 * Active status options for the active filter (value + message descriptor, Spanish defaults).
 */
export const activeOptions: ReadonlyArray<{
  value: string;
  message: MessageDescriptor;
}> = [
  { value: 'true', message: activeStatusMessages.active },
  { value: 'false', message: activeStatusMessages.inactive },
];
